import type { SymbolLimits } from '@/services/eye-v2-service/types'
import { useCoreStore } from '@/stores/coreStore'
import { buildSymbol } from '@/utils/quoteHelpers'
import type { MarketType } from '@/utils/types'
import { getBuyMarketType } from '@/utils'
import { ref, type Ref } from 'vue'
import { useAutoRefresh } from '../useAutorefresh'

export const useCexLimitsRefresher = (
  cex: Ref<string>,
  asset: Ref<string>,
  marketType: Ref<MarketType>,
  quote: string = 'USDT',
) => {
  const coreStore = useCoreStore()
  const limits = ref<SymbolLimits>()

  const updateLimits = async () => {
    const resolvedMarketType = getBuyMarketType(marketType.value)
    const symbol = buildSymbol(asset.value, quote, resolvedMarketType)
    const actionKey = `limits/${cex.value}/swap/${asset.value}`.toLowerCase()
    if (['bingx'].includes(cex.value.toLowerCase())) {
      try {
        const lev = await coreStore.fetchLeverage(actionKey, cex.value, symbol)
        limits.value = {
          amount_min: null,
          amount_max: null,
          cost_min: null,
          cost_max: lev?.max_pos_long ?? null,
          leverage_max: lev?.max_lev_long ?? null,
        }
      } catch {
        console.error(`updateLimits fetch error`)
      }
    } else {
      limits.value = await coreStore.fetchLimits(actionKey, cex.value, 'swap', asset.value)
    }
  }

  const limitsRefresher = useAutoRefresh(async () => {
    await updateLimits()
  }, 30000)

  return {
    limitsRefresher,
    updateLimits,
    limits,
  }
}
